export default "__VITE_PUBLIC_ASSET__cf7973d5__"